var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['waiting-connection', _vm.className],attrs:{"data-cy":"waitingInitialDataMessage"}},[_c('span',[_vm._v(_vm._s(_vm.deviceConnectedText))]),_c('span',[_vm._v(_vm._s(_vm.waitingInitialDataText))])])}
var staticRenderFns = []

export { render, staticRenderFns }